import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import Modal2 from "../../../components/modalsus2026/ModalSus";

const Suscripcion = () => {

    const [t, i18n] = useTranslation("home");
    const [t2] = useTranslation("global");
    const [isModalOpen2, setIsModalOpen2] = useState(false);

    const openModal2 = () => {


        setIsModalOpen2(true);
    };

    const closeModal2 = () => {
        setIsModalOpen2(false);
    };

    const trackAnalyticsClick = (label) => {
        window.gtag('event', 'click', {
            event_category: 'Ideas',
            event_label: label,
            value: 1
        });
    };

    return (
        <div className="_ngcontent-ng-c2574764019">
            <section _ngcontent-ng-c3151073329="" aria-label="Suscripción al boletín" class="blog-newsletter-cta blog-newsletter-cta-sin">
                <div _ngcontent-ng-c3151073329="" class="blog-newsletter-cta__container">
                    <p _ngcontent-ng-c3151073329="" class="blog-newsletter-cta__message"><span
                        _ngcontent-ng-c3151073329="" class="blog-newsletter-cta__message-desktop">{(t2('general.suscribirsel'))}</span><span _ngcontent-ng-c3151073329=""
                            class="blog-newsletter-cta__message-mobile">{(t2('general.suscribirsel2'))}</span></p><button
                                _ngcontent-ng-c3151073329="" type="button" class="blog-newsletter-cta__button"><span
                                    _ngcontent-ng-c3151073329="" class="blog-newsletter-cta__button-desktop" onClick={() => {openModal2(); trackAnalyticsClick('Ideas - Suscribirse')}}>{(t2('general.suscribirsebtn'))}</span><span _ngcontent-ng-c3151073329=""
                                class="blog-newsletter-cta__button-mobile" onClick={() => {openModal2(); trackAnalyticsClick('Ideas - Suscribirse')}}>{(t2('general.suscribirsebtn2'))}</span></button>
                </div>
            </section>
            <Modal2 isOpen={isModalOpen2} closeModal={closeModal2} />
        </div>
    );
};

export default Suscripcion;